export default {"src":"/_next/static/image/public/images/flags/flag_61.288dfc0d6eace9d5f3a526ff7c8a5acb.svg","height":16,"width":25};